import { Map, fromJS } from 'immutable';

export function request(state, { userId, multiple }) {
    state = state.set(
        'multiples',
        state.get('multiples', Map()).set(
            userId,
            state
                .getIn([ 'multiples', userId ], Map())
                .set(multiple.type, fromJS(multiple))
        )
    );

    return state;
}

export function clear(state, { userId }) {
    return state.setIn([ 'multiples', userId ], Map());
}
